import { useMedplum } from '@medplum/react'
import { useQuery } from '@tanstack/react-query'
import { config } from '@/config'
import type { FaxSentItem } from './useFaxSent'

export function useSentFaxDetail(messageId: string) {
  const medplum = useMedplum()

  return useQuery({
    queryKey: ['sent-fax-detail', messageId],
    queryFn: async (): Promise<FaxSentItem> => {
      const baseUrl = config.middlewareUrl
      const res = await fetch(`${baseUrl}/order/sent-faxes/${messageId}`, {
        headers: { Authorization: `Bearer ${medplum.getAccessToken()}` },
      })

      if (!res.ok) throw new Error(`Failed to fetch sent fax: ${res.status}`)

      return res.json()
    },
  })
}
